exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".appMargin0[data-v-3879796c]{margin-left:0!important;margin-right:100px;transition:5s!important}.modal fade show d-block[data-v-3879796c]{background:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3879796c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/view/dashboard/dashboardReportsDetails.vue
// module id = 1508
// module chunks = 0